import React, { useEffect, useState } from 'react';
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
type CountdownProps = {
  variant?: 'light' | 'dark';
};
export function Countdown({
  variant = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const isDark = variant === 'dark';
  const boxClass = isDark ? 'bg-white/15 text-white' : 'bg-[#3b3350] text-white';
  const labelClass = isDark ? 'text-white/70' : 'text-[#7c6aa8]';
  const units = [{
    value: pad(hrs),
    label: 'HORAS'
  }, {
    value: pad(mins),
    label: 'MIN'
  }, {
    value: pad(secs),
    label: 'SEG'
  }];
  return <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-66" data-mp="y0wrfchtfgg9">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-67" data-mp="t2ljj7b2zg0o" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-68" data-mp="t1k831q5krif">
            <div className={`${boxClass} font-serif-display text-2xl sm:text-3xl font-semibold w-14 sm:w-16 py-1.5 rounded-xl text-center tabular-nums shadow-md`} data-id="element-69" data-mp="17rhpmytkuiyn">
              {u.value}
            </div>
            <span className={`${labelClass} text-[10px] font-semibold tracking-widest mt-1`} data-id="element-70" data-mp="f33s0k6ehonm">
              {u.label}
            </span>
          </div>
          {i < units.length - 1 && <span className={`font-serif-display text-2xl sm:text-3xl font-semibold pb-4 ${isDark ? 'text-white/60' : 'text-[#7c6aa8]'}`} data-id="element-71" data-mp="o41ugy16xo43">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}